// contact — the FIRST step of the storefront funnel.
//
// The signup used to open on the meter chooser (ZIP or ESI ID), and a shopper
// who left before the credit step left NOTHING behind: no name, no email, no
// way for an operator to follow up. The funnel's own abandonment was
// unmeasurable and unactionable.
//
// So the four contact fields move to the front. Submitting them creates the
// prospect immediately — before any meter is known — which is why
// `CreateProspectInput.serviceability` is optional: a lead is a person who
// started, not a resolved service point.
//
// ── WHAT THIS STEP DELIBERATELY DOES NOT ASK ──────────────────────────────
//
// No date of birth, no SSN/ITIN, no address, no consent checkbox, no OTP. Those
// stay exactly where they are, at the credit step, behind the disclosures that
// belong with them. Step one asks only what is needed to call someone back.
//
// The email captured here is UNVERIFIED — the OTP that proves it still lives at
// the credit step — so nothing may be mailed to it on the strength of this
// submission alone.
import { z } from 'zod';
import { CreditContactSchema } from './credit.js';
/**
 * The step-one payload.
 *
 * Email and phone reuse `CreditContactSchema`'s rules rather than restating
 * them, so the SPA, the BFF and the credit step can never disagree about what a
 * valid email or a valid NANP number is. Name matches `CustomerNameSchema`'s
 * bounds for the same reason — but WITHOUT `dateOfBirth`, which is the credit
 * step's to ask.
 */
export const LeadContactRequestSchema = z
    .object({
    firstName: z.string().trim().min(1).max(80),
    lastName: z.string().trim().min(1).max(80),
})
    .merge(CreditContactSchema)
    .strict();
/**
 * The reply.
 *
 * Carries NO personal data back — the browser already has what it sent, and
 * echoing contact details would put them in logs and caches for nothing. Only
 * whether the lead was recorded, so the SPA can move to the meter chooser.
 */
export const LeadContactResponseSchema = z
    .object({
    captured: z.literal(true),
})
    .strict();
//# sourceMappingURL=contact.js.map